import { toSlug } from './lib/emneknagg'

export function equals(emneknaggA, emneknaggB) {
  return toSlug(emneknaggA) === toSlug(emneknaggB)
}

export function emneknaggList(valgteEmneknagger) {
  return valgteEmneknagger.map(toSlug).sort().join(';')
}

export function emneknaggUrl(baseUrl, valgteEmneknagger) {
  if (!valgteEmneknagger?.length) {
    return `${baseUrl || '/'}`
  }
  return `${baseUrl}/emneknagger/${emneknaggList(valgteEmneknagger)}`
}

export function stillingUrl(baseUrl, slug, valgteEmneknagger) {
  const emneknaggParam = valgteEmneknagger?.length
    ? `?emneknagger=${emneknaggList(valgteEmneknagger)}`
    : ''
  return `${baseUrl}/stilling/${slug}${emneknaggParam}`
}

export function apiUrl(baseUrl, sok = {}) {
  const { valgteEmneknagger = [] } = sok
  return `${baseUrl}/api/sok/${valgteEmneknagger.join(';')}`
}
